module.exports = __webpack_public_path__ + "media/images/icons/flags/CU-6677236e14fccdcca1973cfa32863456.svg";